export const timetableColors: { [theme: string]: string[] } = {
  ashes: [
    "#c7ae95",
    "#c7c795",
    "#aec795",
    "#95c7ae",
    "#95aec7",
    "#ae95c7",
    "#c795ae",
    "#c79595",
  ],
  chalk: [
    "#fb9fb1",
    "#eda987",
    "#ddb26f",
    "#acc267",
    "#12cfc0",
    "#6fc2ef",
    "#e1a3ee",
    "#deaf8f",
  ],
  eighties: [
    "#f2777a",
    "#f99157",
    "#fc6",
    "#9c9",
    "#6cc",
    "#69c",
    "#c9c",
    "#d27b53",
  ],
  google: [
    "#cc342b",
    "#f96a38",
    "#fba922",
    "#198844",
    "#3971ed",
    "#79a4f9",
    "#a36ac7",
    "#ec9998",
  ],
  mocha: [
    "#cb6077",
    "#d28b71",
    "#f4bc87",
    "#beb55b",
    "#7bbda4",
    "#8ab3b5",
    "#a89bb9",
    "#bb9584",
  ],
  monokai: [
    "#f92672",
    "#fd971f",
    "#f4bf75",
    "#a6e22e",
    "#a1efe4",
    "#66d9ef",
    "#ae81ff",
    "#c63",
  ],
  ocean: [
    "#bf616a",
    "#d08770",
    "#ebcb8b",
    "#a3be8c",
    "#96b5b4",
    "#8fa1b3",
    "#b48ead",
    "#ab7967",
  ],
  "oceanic-next": [
    "#ec5f67",
    "#f99157",
    "#fac863",
    "#99c794",
    "#5fb3b3",
    "#69c",
    "#c594c5",
    "#ab7967",
  ],
  paraiso: [
    "#ef6155",
    "#f99b15",
    "#fec418",
    "#48b685",
    "#5bc4bf",
    "#06b6ef",
    "#815ba4",
    "#e96ba8",
  ],
  railscasts: [
    "#da4939",
    "#cc7833",
    "#ffc66d",
    "#a5c261",
    "#519f50",
    "#6d9cbe",
    "#b6b3eb",
    "#bc9458",
  ],
  tomorrow: [
    "#c66",
    "#de935f",
    "#f0c674",
    "#b5bd68",
    "#8abeb7",
    "#81a2be",
    "#b294bb",
    "#a3685a",
  ],
  twilight: [
    "#cf6a4c",
    "#cda869",
    "#f9ee98",
    "#8f9d6a",
    "#afc4db",
    "#7587a6",
    "#9b859d",
    "#9b703f",
  ],
};
